/**
 * Hook per estrarre user_id da Auth0
 */

import { useAuth0 } from '@auth0/auth0-react';
import { useMemo } from 'react';

/**
 * Hook per ottenere user_id da Auth0
 * Restituisce il sub (user_id) dell'utente autenticato
 */
export function useAuth0UserId(): string | null {
  const { user, isAuthenticated } = useAuth0();

  return useMemo(() => {
    if (!isAuthenticated || !user) {
      return null;
    }

    // Auth0 user_id è nel campo 'sub' (es: "auth0|123456")
    return user.sub || null;
  }, [user, isAuthenticated]);
}

